<template>
  <div>
    <div v-if="$consts.ZONA !== 'RIIL'" class="corner-ribbon top-left red shadow">
      <span>{{ $consts.ZONA }}</span>
    </div>
    <v-app-bar color="primary" app flat height="66">
      <v-avatar size="30px" class="white mr-3" v-if="showSidebar">
        <v-app-bar-nav-icon :color="darkMode ? 'primary' : 'primary'" @click.stop="$store.commit('main/lToggle')"></v-app-bar-nav-icon>
      </v-avatar>

      <div class="container pu">
        <v-toolbar flat class="primary">
          <img v-if="!showSidebar" class="mt-2" src="https://cdn.siap.id/s3/simpkb/asset%20img/Elearning/logo-kemdikbudristek-bg-dark.png" alt="Diklat GTK" height="45" />
          <v-spacer></v-spacer>
          <div class="mx-2">
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp && false"
              text
              class="menus white--text pr-2"
              active-class="menus-active"
              style="text-transform: capitalize"
              :href="$consts.PORTAL"
              >Diklat GTK
            </v-btn>

            <v-menu open-on-hover bottom :offset-y="offset" v-if="$vuetify.breakpoint.mdAndUp && false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" text v-bind="attrs" v-on="on" :ripple="false" class="menus white--text px-1" style="text-transform: capitalize"
                  >Seri <v-icon small>mdi-chevron-down</v-icon></v-btn
                >
              </template>

              <v-list>
                <v-list-item v-for="(item, index) in series" :key="index" @click="toUrl(item)">
                  <v-list-item-title>{{ item.nama }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu open-on-hover bottom :offset-y="offset" v-if="$vuetify.breakpoint.mdAndUp && false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" text v-bind="attrs" v-on="on" :ripple="false" class="menus black--text px-1" style="text-transform: capitalize"
                  >Ingin Bertanya? <v-icon small>mdi-chevron-down</v-icon></v-btn
                >
              </template>

              <v-list>
                <v-list-item v-for="(item, index) in itemFaqs" :key="index" :to="{ name: 'faq', params: { instansi_id: item.id } }">
                  <v-list-item-title>{{ item.nama }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu open-on-hover left offset-y :nudge-width="250" max-height="600" v-if="$vuetify.breakpoint.mdAndUp">
              <template v-slot:activator="{ on, attrs }">
                <v-btn rounded v-bind="attrs" v-on="on" color="white"> <v-icon color="grey darken-1">mdi-apps</v-icon> Layanan Pendukung </v-btn>
              </template>
              <v-list dense>
                <v-list-item class="white--text" v-for="item in layanans" :key="item.index" @click="toURL(item)">
                  <v-list-item-icon class="mx-0 px-0">
                    <v-icon left color="success">mdi-text-box-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span style="white-space: normal">{{ item.nama }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
<!--                <div class="font-weight-bold mx-6 py-2">Arsip Layanan</div>-->
<!--                <v-divider></v-divider>-->
<!--                <v-list-item class="white&#45;&#45;text" v-for="item in filterArsip(layanans, true)" :key="item.index" @click="toURL(item)">-->
<!--                  <v-list-item-icon class="mx-0 px-0">-->
<!--                    <v-icon left color="error">mdi-text-box-remove-outline</v-icon>-->
<!--                  </v-list-item-icon>-->
<!--                  <v-list-item-content>-->
<!--                    <v-list-item-title>-->
<!--                      <span style="white-space: normal">{{ item.nama }}</span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item-content>-->
<!--                </v-list-item>-->
              </v-list>
            </v-menu>
            <v-menu
              open-on-hover
              class="mx-1"
              left
              offset-y
              :nudge-width="200"
              max-height="400"
              v-if="$vuetify.breakpoint.smAndDown && current_user && !current_user.is_super_admin && false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed small fab v-bind="attrs" v-on="on" color="rgba(255, 255, 255, 0.5">
                  <v-icon color="grey darken-1">mdi-apps</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item class="grey--text" v-for="item in layanans" :key="item.index" @click="toURL(item)">
                  <v-list-item-icon class="mx-0 px-0">
                    <v-avatar :size="30" class="mr-2"> <img src="https://cdn.siap.id/s3/simpkb/Aset%20Mobile/app-launcher-simpkb.png" alt="avatar"/></v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <div class="">Arsip Layanan</div>
                    <v-divider></v-divider>
                    <v-list-item-title>
                      <span style="white-space: normal">{{ item.nama }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-app-bar-nav-icon
              class="primary"
              small
              style="color: white; border-radius: 5px"
              v-if="$vuetify.breakpoint.smAndDown"
              right
              @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
          </div>

          <!-- Notification Icon with Dropdown -->
          <v-menu v-if="notificationCount > 0" v-model="menuNotif" :close-on-content-click="false" offset-y transition="slide-x-reverse-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-badge class="mx-4" :content="notificationCount" color="red" overlap>
                <v-icon v-bind="attrs" color="white" v-on="on">
                  mdi-bell
                </v-icon>
              </v-badge>
            </template>

            <v-card>
              <v-list>
                <v-list-item-group v-if="current_user.informasi.length">
                  <v-list-item
                    v-for="(notification, index) in current_user.informasi"
                    :key="index"
                    :class="{
                      'grey lighten-2 px-2': notification.is_baca === 0,
                      ' px-2': notification.is_baca !== 0
                    }"
                  >
                    <v-list-item-content class="px-4" @click="goTo(notification.id)">
                      <v-list-item-title class="font-weight-bold" style="font-size: 11px">{{ notification.judul }}</v-list-item-title>
                      <v-list-item-subtitle style="font-size: 10px">{{ stripHtml(formatMessage(notification.pesan, notification)).slice(0, 50) }}</v-list-item-subtitle>
                      <v-divider class="mt-4" v-if="index < current_user.informasi.length - 1"></v-divider>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title>No notifications</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu v-else v-model="menuNotif" :close-on-content-click="false" offset-y transition="slide-x-reverse-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-icon id="notifikasi" v-bind="attrs" color="white" v-on="on" class="mx-4">
                mdi-bell
              </v-icon>
            </template>

            <v-card>
              <v-list>
                <v-list-item-group v-if="current_user.informasi.length">
                  <v-list-item
                    v-for="(notification, index) in current_user.informasi"
                    :key="index"
                    :class="{
                      'grey lighten-2 px-2': notification.is_baca === 0,
                      ' px-2': notification.is_baca !== 0
                    }"
                  >
                    <v-list-item-content class="px-4" @click="goTo(notification.id)">
                      <v-list-item-title class="font-weight-bold" style="font-size: 11px">{{ notification.judul }}</v-list-item-title>
                      <v-list-item-subtitle style="font-size: 10px">{{ stripHtml(formatMessage(notification.pesan, notification)).slice(0, 50) }}</v-list-item-subtitle>
                      <v-divider class="mt-4" v-if="index < current_user.informasi.length - 1"></v-divider>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title>Pesan tidak tersedia</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <!--          <v-icon v-else class="mx-4" color="white">-->
          <!--            mdi-bell-->
          <!--          </v-icon>-->
          <v-avatar v-if="$vuetify.breakpoint.mdAndUp" @click.stop="$store.commit('main/rToggle')" background-color="primary">
            <a>
              <v-avatar id="akun" :size="40" color="white">
                <v-icon large color="primary" id="avatar">mdi-account-circle</v-icon>
              </v-avatar>
            </a>
          </v-avatar>
        </v-toolbar>

        <div class="text-right ml-5"></div>
      </div>
    </v-app-bar>
    <v-navigation-drawer right v-model="drawer" app fixed temporary width="300">
      <v-card flat class="pa-5">
        <v-list class="mt-0 pt-0">
          <v-list-item two-line>
            <v-list-item-avatar>
              <img v-if="user.image" :src="user.image.url.logo" alt="avatar" />
              <img
                v-else
                :src="
                  current_user && current_user.kelamin == 'L'
                    ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                    : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                "
                alt="avatar"
              />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="primary--text font-weight-bold">{{ user.name }}</v-list-item-title>
              <v-list-item-subtitle style="white-space: normal">{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-5"></v-divider>
        <v-list v-if="false">
          <v-list-item-group active-class="primary--text">
            <v-list-item :href="$consts.PORTAL">
              <span class="menus subtitle">Diklat GTK</span>
            </v-list-item>

            <v-list-group :value="true" no-action>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Seri</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="item in items" :key="item.i" @click="toUrl(item)">
                <v-list-item-title class="ml-n10" style="white-space: normal" v-text="item.nama"></v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group :value="true" no-action v-if="false">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Ingin Bertanya?</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(item, index) in itemFaqs" :key="index" :to="{ name: 'faq', params: { instansi_id: item.id } }">
                <v-list-item-title>{{ item.nama }}</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list class="mt-0 pt-0" v-if="isCan('kelas-read')">
              <v-list-item class="grey--text" @click="switchRole">
                <v-list-item-action class="primary2 rounded-lg">
                  <v-icon class="ma-1 primary--text">mdi-swap-horizontal</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <span class="caption grey--text">Hak Akses</span>
                  <v-list-item-title style="white-space: normal">{{ peran ? peran : "Admin" }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-item-group>
        </v-list>
        <v-list>
          <v-list-item-group>
            <v-list-item @click="logout">
              <span class="menus subtitle">Keluar</span>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-navigation-drawer>
    <PilihInstansi ref="dlg" />
  </div>
</template>

<script>
import { BASE_API } from "@/const";
import { isCan } from "@/tools";
import PilihInstansi from "../modules/instansi/components/PilihInstansiDialog";
const lc = window.localStorage;

// @group Global Component
export default {
  components: {
    PilihInstansi
  },
  data() {
    return {
      // ✅ Hardcode layanan di sini, tanpa perlu load API lagi
      layanans: [
        {
          nama: "SIM Diklat Mandiri",
          url: "https://diklat-demo.simpkb.id/",
          arsip: false
        },
        {
          nama: "Digital Kredensial",
          url: "https://kredensial.demo.siap.id/",
          arsip: false
        }
      ],
      sidebar: false,
      avatar: null,
      menu: false,
      menuNotif: false,
      frawer: true,
      drawer: false,
      loading: false,
      itemFaqs: [
        {
          id: 1,
          nama: "FAQ"
        }
      ],
      offset: true,
      notifications: [
        // Example notifications
        { title: "New Message", message: "You have a new message from John." },
        { title: "Update Available", message: "A new update is available for your app." },
        { title: "Meeting Reminder", message: "Don’t forget the meeting at 3 PM." }
      ]
    };
  },
  computed: {
    showSidebar() {
      return isCan("kelas-read") && this.$route.path.includes("kelola/");
    },

    notificationCount() {
      return this.current_user.informasi.filter(item => item.is_baca === 0).length;
    },

    peran() {
      return this.$store.getters["user/currentRole"];
    },
    items() {
      const seriGbb = this.$store.getters["instansi/instansis"].filter(ins => ins.is_gbb == 0);
      return seriGbb;
    },
    series() {
      const seriGbb = this.$store.getters["instansi/instansis"].filter(ins => ins.is_gbb == 0);
      return seriGbb;
    },
    user() {
      let u = this.$store.getters["user/user"];
      return u ? u : null;
    },
    instansiTerpilih() {
      let i = this.$store.getters["instansi/instansi_aktif"];
      if (i && i.roleku && i.roleku.id == 3) {
        return false;
      } else {
        return true;
      }
    },
    darkMode() {
      return lc.getItem("DARKMODE") == "true" ? true : false;
    }
  },
  mounted() {
    // ❌ Tidak perlu load layanan dari API lagi
    // Sebelumnya:
    // setTimeout(() => {
    //   this.load();
    // }, 3000);
  },
  methods: {
    // ✅ Method load sudah tidak dipakai, bisa dihapus atau dibiarkan kosong
    // load() {},

    filterArsip(data, isArsip) {
      return data.filter(item => item.arsip == isArsip);
    },

    stripHtml(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },

    formatMessage(message, data) {
      // Replace placeholders with actual values
      return message.replace(/\[([^\]]+)\]/g, (match, key) => data[key] || match);
    },

    truncateHtml(html, maxLength) {
      let div = document.createElement("div");
      div.innerHTML = html;

      let text = div.textContent || div.innerText || "";
      if (text.length <= maxLength) return html;

      let truncatedText = text.substring(0, maxLength);
      let truncatedHtml = div.innerHTML.substring(0, div.innerHTML.indexOf(text) + truncatedText.length);
      let lastIndex = truncatedHtml.lastIndexOf(" ");

      return truncatedHtml.substring(0, lastIndex) + "...";
    },

    toURL(val) {
      window.open(val.url, "_self");
    },

    switchRole() {
      this.$confirm(
        `Silakan pilih Peran`,
        {
          role: this.$store.getters["user/roles"]
        },
        "Pilih Peran"
      )
        .then(res => {
          return this.$store
            .dispatch("user/getPermissionByRole", {
              instansi_id: this.instansi_id,
              peran_id: res.role.id
            })
            .then(() => {
              this.$router.push({
                name: "beranda.admin"
              });
            })
            .catch(e => e);
        })
        .catch(e => e);
    },

    pilihInstansi() {
      this.$refs.dlg
        .open()
        .then(res => res)
        .catch(e => e);
    },

    logout() {
      window.location.href = `${BASE_API}/logoutcas`;
    },

    toUrl(u) {
      window.open(u.url_portal, "_self");
    },

    goTo() {
      // Tutup menu notifikasi jika perlu
      this.menuNotif = false;
      // Periksa apakah sudah berada di halaman yang sama
      if (this.$route.name !== "user.informasi") {
        this.$router.push({ name: "user.informasi" });
      }
    }
  }
};
</script>

<style>
.corner-ribbon.shadow {
  -webkit-box-shadow: 1px 2px 3px #474747;
  box-shadow: 1px 2px 3px #474747;
}
.corner-ribbon.top-left {
  top: 15px;
  left: -50px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
.corner-ribbon.red {
  background: #e43;
}
.corner-ribbon {
  width: 150px;
  background: pink;
  position: fixed;
  text-align: center;
  letter-spacing: 1px;
  color: #f0f0f0;
  z-index: 10;
  font-weight: 600;
  font-size: 12px;
  text-shadow: 1px 1px 1px #474747;
  letter-spacing: 0.1em;
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 1140px;
  }
}
</style>
